import { render, staticRenderFns } from "./EmojiWindow.vue?vue&type=template&id=0d6dcb30&scoped=true&"
import script from "./EmojiWindow.vue?vue&type=script&lang=js&"
export * from "./EmojiWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6dcb30",
  null
  
)

export default component.exports